import { ANALYTICS_KEYS, TerminationReason } from '@/types';
import { useAnalyticContext } from '@/modules/analytic/providers/AnalyticProvider';
import { useCallback } from 'react';

interface TrackPersonalizationProps {
  corpoJobCategory: string;
  categories: string[];
  hasReset: boolean;
}

export const useTrackPersonalization = () => {
  const { track } = useAnalyticContext();

  const trackPersonalization = useCallback(
    ({ corpoJobCategory, categories, hasReset }: TrackPersonalizationProps) => {
      track(ANALYTICS_KEYS.PERSONALIZATION, {
        corpoJobCategory,
        categories,
        termination_reason: TerminationReason.Completed,
        has_reset: hasReset,
      });
    },
    [track]
  );

  return { trackPersonalization };
};
